var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41345 14.7445C6.81811 14.513 6.52043 14.3972 6.43353 14.2304C6.35819 14.0858 6.35809 13.9135 6.43326 13.7689C6.51997 13.602 6.8175 13.4858 7.41258 13.2536L24.3003 6.66327C24.8375 6.45364 25.1061 6.34883 25.2777 6.40616C25.4268 6.45596 25.5437 6.57292 25.5935 6.72197C25.6509 6.8936 25.5461 7.16219 25.3364 7.69937L18.7461 24.5871C18.5139 25.1822 18.3977 25.4797 18.2308 25.5664C18.0862 25.6416 17.9139 25.6415 17.7693 25.5662C17.6025 25.4793 17.4867 25.1816 17.2552 24.5862L14.6271 17.8282C14.5801 17.7074 14.5566 17.647 14.5203 17.5961C14.4881 17.551 14.4487 17.5115 14.4036 17.4794C14.3527 17.4431 14.2923 17.4196 14.1715 17.3726L7.41345 14.7445Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.eb627a1c54580fcf0df1efc8545b0590.svg";
export { ForwardRef as ReactComponent };